import FormFieldViewText from "components/FormFields/ViewText";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import { ScimOauthClient } from "types/generated";

type SettingsSingleSignOnScimDetailsProps = {
  settings: Pick<ScimOauthClient, "clientID" | "accessTokenEndpoint" | "connnectorBaseURL">;
};

const SettingsSingleSignOnScimDetails = ({ settings }: SettingsSingleSignOnScimDetailsProps) => {
  return (
    <>
      <DrawerHeader justify="between">
        <DrawerHeaderTitle title="SCIM settings" />
        <DrawerCloseIcon />
      </DrawerHeader>
      <DrawerBody gap="x-large">
        <FormFieldViewText
          label="SCIM connector base URL"
          value={settings.connnectorBaseURL}
          withCopy
          noMargin
        />
        <FormFieldViewText
          label="Access token endpoint"
          value={settings.accessTokenEndpoint}
          withCopy
          noMargin
        />
        <FormFieldViewText label="Client ID" value={settings.clientID} withCopy noMargin />
      </DrawerBody>
    </>
  );
};

export default SettingsSingleSignOnScimDetails;
